import Vue from '../main/vue';
import Product from './components/Product.vue';
import ProductInfo from './components/ProductInfo.vue';
import ProductMedia from './components/ProductMedia.vue';
import AddToProjectButton from './components/AddToProjectButton.vue';
import VariationActions from './components/VariationActions.vue';

const loadProduct = () => {
  if (document.querySelector('.product')) {
    new Vue({
      el: '.product',
      comments: true,
      components: {
        'slo-product': Product,
        'slo-product-info': ProductInfo,
        'slo-product-media': ProductMedia,
        'slo-add-to-project': AddToProjectButton,
        'slo-variation-actions': VariationActions
      }
    });
  }
};

export default loadProduct;
